// extracted by mini-css-extract-plugin
export default {"body":"styles_body__PNawk","content":"styles_content__be3pq","actionButton":"styles_actionButton__MMwlK","text":"styles_text__6NzdS","smallText":"styles_smallText__VEjyx"};